(function () {
    angular.module('tradersyard').component('tyBaseNavigationSidebar', {
        template: `
            <div class="new-sidebar-block" ng-class="{'swipe-open': $ctrl.showSideBar}" ng-show="$ctrl.userId" ng-clock>
                <div class="sidebar-container" elastic-widget="" elastic-widget-offset="#head:#foot" elastic-widget-padding="{{$ctrl.elasticWidgetPadding}}">
                    <div class="sidebar-exhibitions sidebar-section" ng-show="$ctrl.exhibitions.length > 0">
                        <h2>Exhibitions</h2>

                        <div class="group query sidebar-section-content"
                             flex-scroll="exhibition"
                             flex-scroll-fn="query"
                             dlex-scroll-dist="200"
                        >
                            <div class="exhibition-nodes-list">
                                <div class="table-scroll">
                                    <table class="table-layout">
                                        <tr ng-repeat="node in $ctrl.exhibitions">
                                            <td class="picture">
                                                <a ng-href="/exhibition/{{node.id}}">
                                                    <div class="thumbnail">
                                                        <img ng-src="{{node.picture.source|thumb:45:45}}" alt="">
                                                    </div>
                                                </a>
                                            </td>
                                            <td class="data">
                                                <a ng-href="/exhibition/{{node.id}}">
                                                    <b ng-bind="node.name" title="{{node.name}}"></b>
                                                </a>
                                                <p ng-bind="node.exhibition_started_at|moment:'L LT'"></p>
                                            </td>
                                            <td class="author" style="width:74px">
                                                <a ng-href="/{{node.owner.id}}">
                                                    <div class="thumbnail">
                                                        <img ng-src="{{node.owner.picture.source|thumb:45:45}}" alt="">
                                                    </div>
                                                </a>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sidebar-webinars sidebar-section" ng-class="{'without-exhibition': $ctrl.exhibitions.length == 0}">
                        <div class="sidebar-section--heading">
                            <h2>{{$ctrl.officesLabel}}</h2>
                            <ty-group-sidebar-dropdown/>
                        </div>
                        <ty-group-sidebar/>
                    </div>
                    <div class="sidebar-offices sidebar-section" ng-class="{'without-exhibition': $ctrl.exhibitions.length == 0}">
                        <h2>Events</h2>

                        <div class="webinar query sidebar-section-content"
                             flex-scroll="webinar"
                             flex-scroll-fn="query"
                             dlex-scroll-dist="200"
                        >
                            <div class="row">
                                <div class="c-12">
                                    <div class="webinars-navigation">
                                        <select ng-change="$ctrl.changeWebinarsType()" ng-model="$ctrl.selectedWebinarsType">
                                            <option value="recommended" ng-selected="selectedWebinarsType == 'recommended'" ng-show="!groupMode">Recommended</option>
                                            <option value="all" ng-selected="$ctrl.selectedWebinarsType == 'all'" ng-show="!groupMode">All</option>
                                            <option value="upcoming" ng-selected="$ctrl.selectedWebinarsType == 'upcoming'" ng-show="!groupMode">Upcoming</option>
                                            <option value="closed" ng-selected="$ctrl.selectedWebinarsType == 'closed'">Closed</option>
                                            <option value="my" ng-selected="$ctrl.selectedWebinarsType == 'my'">My</option>
                                            <option value="own" ng-selected="$ctrl.selectedWebinarsType == 'own'">Own</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="webinar-nodes-list">
                                <div class="table-scroll">
                                    <table class="table-layout">
                                        <tr ng-repeat="node in $ctrl.webinars">
                                            <td class="picture">
                                                <a ng-href="/webinar/{{node.id}}">
                                                    <div class="thumbnail">
                                                        <img ng-src="{{node.picture.source|thumb:45:45}}" alt="">
                                                    </div>
                                                </a>
                                            </td>

                                            <td class="data">
                                                <a ng-href="/webinar/{{node.id}}">
                                                    <b ng-bind="node.name" title="{{node.name}}"></b>
                                                </a>
                                                <p ng-bind="node.started_at|moment:'L LT'"></p>
                                            </td>

                                            <td class="author" style="width:74px">
                                                <a ng-href="/{{node.owner.id}}">
                                                    <div class="thumbnail">
                                                        <img ng-src="{{node.owner.picture.source|thumb:45:45}}" alt="">
                                                    </div>
                                                </a>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `,
        bindings: {
            officesLabel: '@',
        },
        controller: NavigationSidebarController,
    });

    NavigationSidebarController.$inject = [
        '$rootScope',
        'AuthService',
        'graph-group-factory',
        'graph-webinar-factory',
        'graph-exhibition-factory',
    ];

    function NavigationSidebarController($rootScope, AuthService, $groupFactory, $webinarFactory, $exhibitionFactory) {
        const ctrl = this;
        const me = $rootScope.me;
        ctrl.userId = me ? me.id : false;
        ctrl.groups = [];
        ctrl.webinars = [];
        ctrl.exhibitions = [];
        ctrl.process = 0;
        ctrl.space = 'me';
        ctrl.elasticWidgetPadding = 0;
        ctrl.grouFfilter = {
            filter: 'my',
            limit: 25,
        };
        ctrl.webinarFfilter = {
            filter: 'my',
            limit: 25,
        };
        ctrl.exhibitionFilter = {
            filter: 'upcoming',
            limit: 25,
        };
        ctrl.featureEnabled = window.featureEnabled;

        $rootScope.$watch(
            function () {
                return $rootScope.$rootScope.showSideBar;
            },
            function () {
                ctrl.showSideBar = $rootScope.$rootScope.showSideBar;
            },
            true
        );

        ctrl.$onInit = function () {
            if (AuthService.getUser()) {
                ctrl.selectedTypeOfGroups = localStorage.getItem(`sidebarTypeOfGroups:${$rootScope.me.id}`) || 'my';
                ctrl.grouFfilter.filter = ctrl.selectedTypeOfGroups;
                ctrl.queryGroups();

                ctrl.selectedWebinarsType =
                    localStorage.getItem(`sidebarTypeOfWebinars:${$rootScope.me.id}`) || 'upcoming';
                ctrl.webinarFfilter.filter = ctrl.selectedWebinarsType;
                ctrl.querywebinars();

                ctrl.queryExhibitions();
            }
        };

        ctrl.changeTypeOfGroups = function () {
            ctrl.grouFfilter.filter = ctrl.selectedTypeOfGroups;
            localStorage.setItem(`sidebarTypeOfGroups:${ctrl.userId}`, ctrl.selectedTypeOfGroups);

            ctrl.groups = [];
            ctrl.queryGroups();
        };

        ctrl.changeWebinarsType = function () {
            ctrl.webinarFfilter.filter = ctrl.selectedWebinarsType;
            localStorage.setItem(`sidebarTypeOfWebinars:${ctrl.userId}`, ctrl.selectedWebinarsType);

            ctrl.webinars = [];
            ctrl.querywebinars();
        };

        ctrl.queryGroups = function () {
            ctrl.process = 1;

            $groupFactory
                .query(ctrl.space, {
                    params: ctrl.grouFfilter,
                })
                .then(function (response) {
                    ctrl.groups = ctrl.groups.concat(response.data.data);

                    if (!localStorage.getItem(`sidebarTypeOfGroups:${ctrl.userId}`) && ctrl.groups.length === 0) {
                        localStorage.setItem(`sidebarTypeOfGroups:${ctrl.userId}`, 'all');
                        ctrl.grouFfilter.filter = 'all';
                        ctrl.selectedTypeOfGroups = 'all';
                        ctrl.queryGroups();
                    }

                    ctrl.process = 0;
                });
        };

        ctrl.querywebinars = function () {
            ctrl.process = 1;

            $webinarFactory
                .query(ctrl.space, {
                    params: ctrl.webinarFfilter,
                })
                .then(function (response) {
                    ctrl.webinars = ctrl.webinars.concat(response.data.data);

                    if (
                        !localStorage.getItem(`sidebarTypeOfWebinars:${ctrl.userId}`) &&
                        response.data.data.length === 0
                    ) {
                        localStorage.setItem(`sidebarTypeOfWebinars:${ctrl.userId}`, 'my');
                        ctrl.webinarFfilter.filter = 'my';
                        ctrl.selectedWebinarsType = 'my';
                        ctrl.querywebinars();
                    }

                    ctrl.process = 0;
                });
        };

        ctrl.queryExhibitions = function () {
            ctrl.process = 1;

            $exhibitionFactory
                .query(ctrl.space, {
                    params: ctrl.exhibitionFilter,
                })
                .then(function (response) {
                    ctrl.exhibitions = ctrl.exhibitions.concat(response.data.data);

                    ctrl.process = 0;
                });
        };

        ctrl.hideSideBar = function () {
            $rootScope.$rootScope.showSideBar = false;
        };
    }
})();
